import AgentAccount from '@/pages/agentManage/agentAccount'
import CheckAccount from '@/pages/agentManage/agentManage'
import CheckLeven from '@/pages/agentManage/agencyManage'
import CheckBackMoney from '@/pages/agentManage/rakeBackManage'

export default [
  {
    path: '/agentAccount',
    name: 'AgentAccount',
    component: AgentAccount,
    meta: { name: '代理账户查询' }
  },
  {
    path: '/agentAccount/checkAccount/:orderId',
    name: 'CheckAccount',
    component: CheckAccount,
    props: true,
    meta: { name: ['代理账户查询', '账户详情'] }
  },
  {
    path: '/agentAccount/checkLeven/:orderId',
    name: 'CheckLeven',
    component: CheckLeven,
    props: true,
    meta: { name: ['代理账户查询', '代理详情'] }
  },
  {
    path: '/agentAccount/checkBackMoney/:orderId',
    name: 'CheckBackMoney',
    component: CheckBackMoney,
    props: true,
    meta: { name: ['代理账户查询', '返佣详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/agentManage/agentAccount.js